<template>
  <div>
    <div>
      <form-wizard
        @on-complete="saveTransaction"
        title
        subtitle
        color="#8cc63f"
        finish-button-text="Submit"
        shape="square"
      >
        <tab-content title="Transaction Details" icon="ti-receipt">
          <div
            style="
              display: flex;
              align-items: center;
              margin-top: 20px;
              flex-direction: column;
            "
          >
            <div
              v-if="formType == 'update'"
              class="col-8"
              style="margin-top: 15px"
            >
              <label>Transaction ID: {{ code }}</label>
            </div>
            <div
              v-if="transactionType == 'ProjectAccountTransaction'"
              class="col-8"
              style="margin-top: 15px"
            >
              <label>Project</label>
              <select class="custom-select" v-model="account_id">
                <option
                  v-for="project in projects"
                  :key="project.code"
                  :value="project.account_id"
                >
                  {{ project.code }} {{ project.name }}
                </option>
              </select>
            </div>
            <div
              v-else-if="transactionType == 'InvestorAccountTransaction'"
              class="col-8"
              style="margin-top: 15px"
            >
              <label>Investor</label>
              <select class="custom-select" v-model="account_id">
                <option
                  v-for="investor in investors"
                  :key="investor.code"
                  :value="investor.account_id"
                >
                  {{ investor.code }}
                </option>
              </select>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Description</label>
              <input
                class="form-control"
                type="text"
                required
                v-model="description"
              />
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Type</label>
              <select class="custom-select" v-model="type">
                <option
                  v-for="transactionType in transactionTypes"
                  :key="transactionType.name"
                  :value="transactionType.id"
                >
                  {{ transactionType.name }}
                </option>
              </select>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Category</label>
              <select class="custom-select" v-model="category_id">
                <option
                  v-for="category in transactionCategories"
                  :key="category.name"
                  :value="category.id"
                >
                  {{ category.name }}
                </option>
              </select>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label id="date">Date</label>
              <input
                class="form-control"
                type="date"
                id="date"
                v-model="date"
              />
            </div>
            <div class="col-8" style="margin-top: 10px; display: flex">
              <div class="col-8" style="padding: 0">
                <label>Amount</label>
                <input
                  class="form-control"
                  min="0"
                  type="number"
                  required
                  v-model="amount"
                />
              </div>
              <div style="padding-right: 0" class="col-4">
                <label>Currency</label>
                <select class="custom-select" v-model="currency_id">
                  <option
                    v-for="currency in currencies"
                    :key="currency.code"
                    :value="currency.id"
                  >
                    {{ currency.code }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-8" style="margin-top: 15px">
              <label>Exchange Rate</label>
              <input
                class="form-control"
                min="0"
                type="number"
                required
                v-model="exchange_rate"
              />
            </div>
            <div class="col-8" style="margin-top: 15px">
              <div style="display: flex">
                <label>Fees</label>
                <label style="font-size: 10px; margin-left: 5px"
                  >(Based on currency)</label
                >
              </div>
              <input
                class="form-control"
                min="0"
                type="number"
                required
                v-model="fees"
              />
            </div>
            <div class="col-8" style="margin-top: 25px">
              <div style="padding: 0" class="col-8">
                <div style="display: flex; margin-top: 10px">
                  <div class="col-6" style="padding: 0; font-weight: bold">
                    USD Summary
                  </div>
                  <div class="col-6" style="padding: 0">
                    {{
                      (amount * exchange_rate - fees * exchange_rate).toFixed(3)
                    }}
                    USD
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab-content>
      </form-wizard>
    </div>
  </div>
</template>
<script>
import TransactionStorer from "../../../../storers/StoreTransaction";
import { mapState } from "vuex";
import MediaBrowser from "../../../common/MediaBrowser.vue";
import TransactionsFilter from "../../../../filters/TransactionsFilter";
export default {
  props: ["formType", "activeTransactionID", "transactionType"],
  data() {
    return {
      transactionTypes: [
        { id: "deposit", name: "Deposit" },
        { id: "withdrawal", name: "Withdrawal" },
      ],
      selectedProject: null,
      selectedInvestor: null,

      // Transaction Details
      account_id: null,
      code: null,
      type: "deposit",
      description: null,
      exchange_rate: 1,
      fees: 0,
      currency_id: null,
      category_id: null,
      amount: 0,
      date: null,
      usdCurrencyID: null,
    };
  },
  components: { MediaBrowser },
  created: function () {
    this.$store.dispatch("searchCurrencies").then(() => {
      var usdCurrency = this.currencies.find((currency) => {
        return currency.code == "USD";
      });
      this.currency_id = usdCurrency.id;
      this.usdCurrencyID = usdCurrency.id;
    });
    if (this.transactionType == "ProjectAccountTransaction") {
      this.$store.dispatch("searchProjects");
    } else if (this.transactionType == "InvestorAccountTransaction") {
      this.$store.dispatch("searchInvestors");
    }
    this.$store.dispatch("searchTransactionCategories");
    if (this.formType == "update") {
      var transactionsFilter = TransactionsFilter();
      transactionsFilter.ids = [this.activeTransactionID];
      this.$store
        .dispatch("searchTransactions", {
          filter: transactionsFilter,
          resultMode: "default",
        })
        .then(() => {
          this.fillForm();
        });
    }
  },
  computed: {
    ...mapState({
      projects: (state) => state.projectStore.projectSearch.projects,
      investors: (state) => state.investorStore.investorSearch.investors,
      currencies: (state) => state.currencyStore.currencySearch.currencies,
      transactionCategories: (state) =>
        state.transactionStore.transactionCategorySearch.transactionCategories,
      activeTransaction: (state) =>
        state.transactionStore.transactionSearch.transactions[0],
    }),
  },
  methods: {
    init() {
      // Transaction Details
      this.account_id = null;
      this.amount = null;
      this.type = null;
      this.currency_id = null;
      this.category_id = null;
      this.fees = 0;
      this.exchange_rate = 1;
      this.date = null;
      this.description = null;
    },

    fillForm() {
      // Transaction Details
      this.account_id = this.activeTransaction.account_id;
      this.amount = this.activeTransaction.amount;
      this.type = this.activeTransaction.type;
      this.currency_id = this.activeTransaction.currency_id;
      this.category_id = this.activeTransaction.category_id;
      this.fees = this.activeTransaction.fees;
      this.exchange_rate = this.activeTransaction.exchange_rate;
      this.date = this.activeTransaction.date;
      this.description = this.activeTransaction.description;
    },

    saveTransaction() {
      // Transaction Details
      var transaction = TransactionStorer();
      if (this.formType == "update") {
        transaction.id = this.activeTransaction.id;
        transaction.code = this.activeTransaction.code;
      }
      transaction.type = this.type;
      transaction.amount = this.amount;
      transaction.currency_id = this.currency_id;
      transaction.category_id = this.category_id;
      transaction.fees = this.fees;
      if (this.transactionType == "ProjectAccountTransaction") {
        transaction.account_type = "project_account";
      } else if (this.transactionType == "InvestorAccountTransaction") {
        transaction.account_type = "investor_account";
      }
      transaction.account_id = this.account_id;
      transaction.exchange_rate = this.exchange_rate;
      transaction.date = this.date;
      transaction.description = this.description;

      this.$emit("saveTransaction", transaction);
    },
  },
  watch: {
    amount() {
      if (this.amount < 0) {
        this.amount = 0;
      }
    },
    exchange_rate() {
      if (this.exchange_rate < 0) {
        this.exchange_rate = 0;
      }
      if (this.currency_id == this.usdCurrencyID) {
        this.exchange_rate = 1;
      }
    },
    currency_id() {
      if (this.currency_id == this.usdCurrencyID) {
        this.exchange_rate = 1;
      }
    },
  },
};
</script>
<style>
.wizard-icon {
  color: rgb(140, 198, 63) !important;
}
.active .wizard-icon {
  color: rgb(255, 255, 255) !important;
}
.wizard-icon-circle {
  border-color: rgb(140, 198, 63) !important;
  background-color: #fafaf7 !important;
}
.stepTitle {
  color: rgb(140, 198, 63) !important;
  margin-top: 5px;
}
.form-control {
  border: 1px solid #ced4da !important;
  background-image: none;
  border-radius: 5px !important;
  padding: 10px;
}
.custom-select {
  background-color: transparent !important;
}
.wizard-btn {
  margin-bottom: 20px !important;
}
.vue-form-wizard.md .wizard-icon-circle {
  width: 100px;
  height: 100px;
  border-radius: 30px;
  font-size: 24px;
}
.vue-form-wizard .wizard-icon-circle .wizard-icon-container.square_shape {
  border-radius: 20px;
  padding: 32px;
}
.vue-form-wizard.md .wizard-nav-pills > li.active > a .wizard-icon {
  font-size: 34px;
}
.vue-form-wizard .wizard-icon-circle .wizard-icon {
  font-size: 34px;
}
.vue-form-wizard.md .wizard-navigation .wizard-progress-with-circle {
  display: none;
}
.vue-form-wizard .wizard-nav-pills > li.active > a {
  cursor: default;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/components/forms/transactionForm.vue